import moment from 'moment'

const date = {
    methods: {
        convertDate(v) {
            if (!v) return '-'

            return moment(v).format('YYYY-MM-DD')
        },
        convertDateWithTime(v) {
            return moment(v).format('YYYY-MM-DD HH:mm')
        },
    },
}

export default date
